import dayjs from 'dayjs';

Pixlee.module('Entities', function(Entities, App, Backbone, Marionette, $) {
    var _this = this,
        API, _API;
    API = {
        getPhoto: function(id) {
            var photo;
            photo = new Entities.Photo({
                album_photo_id: id
            });
            photo.fetch({
                reset: true
            });
            return photo;
        },

        getCustomVideoThumbnail: function(model) {
            // If there is a custom thumbnail in video settings, return it as the thumbnail
            var videoSettings = model.get('video_settings') || {};
            return !_.isEmpty(videoSettings) && _.isTruthy(videoSettings.thumbnail_url) ? videoSettings.thumbnail_url.replace('http://', 'https://') : null;
        },
        getPhotoThumbnailUrl: function(model) {
            var videoThumbnail = this.getCustomVideoThumbnail(model);
            if (videoThumbnail) {
                return videoThumbnail;
            }
            if (!_.isFalsy(model.get('data_file_name'))) {
                return 'https://static.pxlecdn.com/photos/' + model.get('id') + '/medium/' + App.reqres.request('encode:utf8', model.get('data_file_name'));
            }
            if (model.get('medium_url')) {
                return model.get('medium_url').replace('http://', 'https://');
            } else if (model.get('thumbnail_url')) {
                return model.get('thumbnail_url').replace('http://', 'https://');
            } else if (model.get('source_url')) {
                return model.get('source_url').replace('http://', 'https://');
            }
        },
    };


    Entities.Photo = Entities.Model.extend({
        url: function() {
            return App.reqres.request('get:photo:url', this.get('album_photo_id'));
        },
        defaults: {
            _ENTITY_NAME: 'Photo'
        },
        mutators: {
            pixlee_cdn_photos: {
                get: function() {
                    return this.attributes.pixlee_cdn_photos;
                },
                transient: true
            },
            products: {
                get: function() {
                    return this.attributes.products;
                },
                transient: true
            },
            taggedAtFormatted: {
                get: function() {
                    return dayjs(parseInt(this.attributes.tagged_at, 10)).format('MM-DD-YYYY');
                },
                transient: true
            },
            approvedOnDateFormatted: {
                get: function() {
                    return dayjs(parseInt(this.attributes.approved_on_date, 10)).format('MM-DD-YYYY');
                },
                transient: true
            },
            captionFormatted: {
                get: function() {
                    var title;
                    if (!_.isFalsy(this.attributes.title) || this.attributes.title === '') {
                        title = this.attributes.title;
                    } else if (!_.isFalsy(this.attributes.album_title)) {
                        title = this.attributes.album_title;
                    } else if (!_.isFalsy(this.attributes.photo_title)) {
                        title = this.attributes.photo_title;
                    }
                    var decodedTitle = App.request('decode:untrusted:input', title);
                    if (_.isFalsy(decodedTitle)) {
                        return '';
                    }
                    return decodedTitle;
                },
                transient: true
            },
            notesFormatted: {
                get: function() {
                    var notes;
                    if (!_.isFalsy(this.attributes.notes) || this.attributes.notes === '') {
                        notes = this.attributes.notes;
                    }
                    var decodedNotes = App.request('decode:untrusted:input', notes);
                    if (_.isFalsy(decodedNotes)) {
                        return '';
                    }
                    return decodedNotes;
                },
                transient: true
            },
            submitterFormatted: {
                get: function() {
                    var submitter = this.attributes.user_name ||
                                    this.attributes.email_address ||
                                    '';
                    var source = this.attributes.source || 'desktop';

                    if (this.isAnonymousInstagram()) {
                        submitter = 'Instagram User';
                    } else if (source === 'instagram' || source === 'twitter') {
                        submitter = '@' + submitter.replace('@', '');
                    }
                    return submitter;
                },
                transient: true
            },
            submitterHref: {
                get: function() {
                    if (this.get('platform_link')) {
                        if (this.get('source') === 'instagram' && this.get('platform_link').slice(-1) !== '/') {
                            return this.get('platform_link') + '/';
                        } else {
                            return this.get('platform_link');
                        }
                    }
                    if (this.get('submitter_link')) {
                        return this.get('submitter_link');
                    }
                    var userName = this.get('user_name') || '';
                    switch (this.get('source')) {
                        case 'instagram':
                            return 'http://instagram.com/' + userName;
                        case 'twitter':
                            return 'http://twitter.com/' + userName;
                        case 'youtube':
                            return 'https://www.youtube.com/channel/' + this.get('connected_user_social_id');
                        case 'twitch':
                            return 'https://twitch.tv/' + userName;
                        case 'tiktok':
                            return 'https://tiktok.com/@' + userName;
                        default:
                            return 'javascript: void(0)';
                    }
                },
                transient: true
            },
            src: {
                get: function() {
                    var hostName = 'https://static.pxlecdn.com';
                    if (this.get('data_file_name') != null) {
                        return hostName + '/photos/' + this.get('id') + '/original/' + App.reqres.request('encode:utf8', this.get('data_file_name'));
                    }
                    if (this.get('content_type') == 'image' || !this.get('content_type')) {
                        if (this.get('source_url') != null) {
                            return this.get('source_url').replace('http://', 'https://');
                        }
                    } else if (this.get('content_type') == 'video') {
                        return this.get('thumbnail_url').replace('http://', 'https://');
                    }
                    return '';
                },
                transient: true
            },
            submitter_type: {
                get: function() {
                    if (_.isFalsy(this.attributes.source)) {
                        return 'desktop';
                    }
                    return this.attributes.source;
                },
                transient: true
            },
            isVideo: {
                get: function() {
                    if (this.get('content_type') == 'video') {
                        return true;
                    }
                    return false;
                }
            },
            isStory: {
                get: function() {
                    return this.get('subtype') === 'instagram_story';
                }
            },
            posterUrl: {
                get: function() {
                    return this.get('big_url') || this.get('thumbnail_url');
                },
                transient: true
            },
            videoURL: {
                get: function() {
                    var videoUrl = this.get('source_url') || '';
                    return videoUrl.replace('http://', 'https://');
                },
                transient: true
            },
            likeCount: {
                get: function() {
                    return this.get('like_count') || 0;
                },
                transient: true
            },
            shareCount: {
                get: function() {
                    return this.get('share_count') || 0;
                },
                transient: true
            },
            actionLinkFormatted: {
                get: function() {
                    if (_.isFalsy(this.get('action_link'))) {
                        return '';
                    }
                    return App.request('decode:utf8', this.get('action_link'));
                },
                transient: true
            },
            actionLinkTextFormatted: {
                get: function() {
                    if (_.isFalsy(this.get('action_link_text'))) {
                        return '';
                    }
                    return App.request('decode:utf8', this.get('action_link_text'));
                },
                transient: true
            },
            actionLinkTitleFormatted: {
                get: function() {
                    if (_.isFalsy(this.get('action_link_title'))) {
                        return '';
                    }
                    return App.request('decode:utf8', this.get('action_link_title'));
                },
                transient: true
            },
            actionLinkPhotoFormatted: {
                get: function() {
                    if (_.isFalsy(this.get('action_link_photo'))) {
                        return '';
                    }
                    return App.request('decode:utf8', this.get('action_link_photo'));
                },
                transient: true
            }
        },
        isAnonymousInstagram: function() {
            return !this.get('connected_user_id') && this.get('source') === 'instagram';
        },
        isCarouselPhoto: function() {
            return this.subtype === 'carousel';
        },
        // If its NOT the first top content in a carousel
        isCarouselChildContent: function() {
            return this.parent_id !== null;
        },
        parse: function(e) {
            if (_.isFalsy(App.isWidget) && _.isObject(e.data)) {
                return e.data;
            }
            return e;
        },
        toJSONForLightbox: function() {
            var attr = this.toJSON();
            // iterate over all mutators (if there are some)
            _.each(this.mutators, _.bind(function(mutator, name) {
                // check if we have some getter mutations
                if (_.isObject(this.mutators[name]) === true && _.isFunction(this.mutators[name].get)) {
                    attr[name] = _.bind(this.mutators[name].get, this)();
                } else {
                    attr[name] = _.bind(this.mutators[name], this)();
                }
            }, this));
            return attr;
        },
    });

    Entities.PhotosWidgets = Entities.PaginatedCollection.extend({
        model: Entities.Photo,
        server_api: {
            'page': function() {
                return this.currentPage;
            },
            'filter_id': function() {
                return App.recipe.toJSON().filter_sort_id || gon.publication_id;
            },
            'unique_id': function() {
                if (App.recipe && App.recipe.toJSON().sort) {
                    if (App.recipe.toJSON().sort.dynamic || App.recipe.toJSON().sort.random) {
                        var session_hash = '';
                        if (_.isTruthy(gon.distinct_user_hash)) {
                            session_hash = gon.distinct_user_hash;
                        } else if (typeof analytics !== 'undefined' && _.isTruthy(analytics.getAnonymousId())) {
                            session_hash = analytics.getAnonymousId();
                        }
                        return (App.request('murmurhash', this.sessionId, 32) + App.request('murmurhash', session_hash, 32)) % 25;
                    } else {
                        return 0;
                    }
                } else {
                    return 0;
                }
            },
            // Full backwards compatibility
            'per_page': function() {
                // Defaults for Vertical, Coverflow, & Horizontal Displays
                var mobileLinear = 6;
                var tabletLinear = 9;
                var desktopLinear = 9;

                // Defaults for Photowall & Mosaic
                var mobileGrid = 18;
                var tabletGrid = 24;
                var desktopGrid = 30;

                // Page size set by the user in Design Editor
                var displayOptionsPageSize = parseInt(App.displayOptions.get('pageSize'));

                // Deprecated variables but still may exist in old display options
                var mobilePageSize = parseInt(App.displayOptions.get('pageSizeMobile')) || displayOptionsPageSize;
                var tabletPageSize = parseInt(App.displayOptions.get('pageSizeTablet')) || displayOptionsPageSize;

                // True or False
                var isDefaultSize = displayOptionsPageSize === 0;

                /* Interactive & Viewport */
                if (App.displayOptions.get('is_interactive') && this.paginator_core.url.indexOf('view_port') !== -1) {
                    return 100;
                }

                /* Mosaic v1 */
                if (App.MosaicApp) {
                    return 32;
                }

                /* Horizontal, Coverflow, Vertical and Slideshow */
                if (App.HorizontalApp || App.CoverflowApp || App.VerticalApp || App.SlideShowApp) {
                    // Mobile
                    if (gon.isMobile) {
                        return isDefaultSize ? mobileLinear : (mobilePageSize || mobileLinear);
                    }
                    // Tablet
                    if (gon.isTablet) {
                        return isDefaultSize ? tabletLinear : (tabletPageSize || tabletLinear);
                    }
                    // Desktop
                    return isDefaultSize ? desktopLinear : (displayOptionsPageSize || desktopLinear);

                    /* Photowall & Mosaic v2 */
                } else {
                    // Mobile
                    if (gon.isMobile) {
                        return isDefaultSize ? mobileGrid : (mobilePageSize || mobileGrid);
                    }
                    // Tablet
                    if (gon.isTablet) {
                        return isDefaultSize ? tabletGrid : (tabletPageSize || tabletGrid);
                    }
                    // Desktop
                    return isDefaultSize ? desktopGrid : (displayOptionsPageSize || desktopGrid);
                }
            },
            'sortType': function() {
                return this.sortType;
            }
        },
        parse: function(e) {
            if (typeof e.error_code != 'undefined' && e.error_code == 1) {
                window.location.href = '/';
            }
            if (e.data.length === 0 && this.currentPage == 1) {
                this.remaining_count = 0;
            }
            this.next = e.next;

            return e.data;
        },
        toJSONForLightbox: function() {
            var data = [];
            // iterate over all mutators (if there are some)
            _.each(this.models, function(model) {
                if (_.isFalsy(model.get('isUploaderTile'))) {
                    data.push(model.toJSONForLightbox());
                }
            }, this);
            return data;
        },
        filterBy: function(criterias, resetOriginal) {
            var items;
            var _this = this;
            if (_.isFalsy(this._currentCriteria) || !_.isFalsy(resetOriginal)) {
                this._originalModels = this.models;
                this._remaining_count = this.remaining_count;
            }
            // call 'where' if we have criteria
            // or just get all the models if we don't
            if (criterias) {
                items = [];
                _.each(this._originalModels, function(model) {
                    if (criterias.indexOf(model.id) != -1) {
                        items.push(model);
                    }
                });
                // store current criteria
                this._currentCriteria = criterias;
                this.remaining_count = items.length;
            } else {
                items = this._originalModels;
                // this.clearFilterCriterias();
                this.remaining_count = this._remaining_count;
            }

            // reset the filtered collection with the new items
            this.reset(items);
            this.trigger('collection:filtered');
        },
        interactiveWidgetFilterBy: function(criterias, resetOriginal) {
            var items;
            var _this = this;
            if (_.isFalsy(this._currentCriteria) || !_.isFalsy(resetOriginal)) {
                if (!_.isFalsy(this._originalModels)) {
                    this._originalModels = _.union(this._originalModels, this.models);
                } else {
                    this._originalModels = this.models;
                }
                this._remaining_count = this.remaining_count;
            }
            // call 'where' if we have criteria
            // or just get all the models if we don't
            if (criterias) {
                items = [];
                _.each(this._originalModels, function(model) {
                    if (criterias.indexOf(model.id) != -1) {
                        items.push(model);
                    }
                });
                // store current criteria
                this._currentCriteria = criterias;
                this.remaining_count = items.length;
            } else {
                items = this._originalModels;
                this.remaining_count = this._remaining_count;
            }
            /* Since we are client side filtering, an isRendered flag may be set on the model since we cache them in this._originalModels
            we need to reset the flag if we are going to re-use cached models in the photos collection */
            _.each(items, function(item) {
                item.set('isRendered', false);
            });
            // reset the filtered collection with the new items
            this.reset(items);
            this.trigger('collection:filtered');
        },
        filterPhotosWithLocation: function(resetOriginal, viewPort) {
            var _this = this;
            var filtered = this.models.filter(function(photo) {
                var lat = photo.get('latitude');
                var lng = photo.get('longitude');
                if (lat && lng) {
                    var latLng = new google.maps.LatLng(lat, lng);
                    if (viewPort.contains(latLng)) {
                        return photo;
                    }
                }
            });
            this.interactiveWidgetFilterBy(_.pluck(filtered, 'id'), resetOriginal);
        },
        resetToOriginal: function() {
            if (!_.isFalsy(this._originalModels)) {
                this.reset(this._originalModels);
                this.remaining_count = this._remaining_count;
            } else {
                this._originalModels = this.models;
            }
        }
    });
    Entities.PhotosWidgetsMosaic = Entities.PhotosWidgets.extend({});
    App.reqres.setHandlers({
        'get:photo': function(id) {
            return API.getPhoto(id);
        },

        'get:photo:tumbnail': function(model) {
            return API.getPhotoThumbnailUrl(model);
        },
    });


});
